import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
  signal,
} from '@angular/core';

import { RouterLink, RouterModule } from '@angular/router';
import { AppMenuitem } from './app.menuitem';
import { LayoutService } from '../service/layout.service';
import { APP_NAME, SHOW_ETHNIKI_LOGO } from '../../utils';
import { AppConfigService } from '../../services/app-config.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [AppMenuitem, RouterModule, RouterLink, CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="layout-sidebar-logo-container">
      <a routerLink="/">
        <img alt="Logo" [src]="sidebarLogo()" class="logo-container" />
      </a>
      @if(!this.layoutService.isMobile()){
      <div
        class="layout-toggle-sidebar"
        [class.layout-toggle-sidebar-open]="isSidebarOpen()"
        [class.layout-toggle-sidebar-close]="!isSidebarOpen()"
      >
        <a class="toggle-button" (click)="layoutService.onMenuToggle()">
          <img
            src="./assets/images/arr079.svg"
            [class.rotate-180]="isSidebarOpen()"
            class="arrow-icon"
            alt="Toggle Arrows"
          />
        </a>
      </div>
      }
    </div>
    <div>
      <ul class="layout-menu">
        @for (item of layoutService.sidebarItems(); track $index; let i =
        $index) { @if (!item.separator) {
        <li app-menuitem [item]="item" [index]="i" [root]="true"></li>
        } @if (item.separator) {
        <li class="menu-separator"></li>
        } }
      </ul>
    </div>
    @if(showEthnikiLogo) {
    <div
      style="
        position: absolute;
        bottom: 1rem;
        z-index: 10;
      "
      [ngStyle]="{
        left: layoutService.layoutState().staticMenuDesktopInactive ? '50%' : '2.5rem',
        transform: layoutService.layoutState().staticMenuDesktopInactive ? 'translateX(-50%)' : 'none'
      }"
    >
      <img
        src="../../../assets/media/logos/logo_ethniki_light.png"
        alt="Ethniki"
        [ngStyle]="{
          height: layoutService.layoutState().staticMenuDesktopInactive ? '20px' : '38px',
          width: 'auto',
          display: 'block',
          opacity: '0.95'
        }"
      />
    </div>
    }
  `,
})
export class AppMenu {
  layoutService = inject(LayoutService);
  private configService = inject(AppConfigService);
  private appName = inject(APP_NAME);
  showEthnikiLogo = inject(SHOW_ETHNIKI_LOGO);

  isSidebarOpen = computed(() => {
    return (
      this.layoutService.layoutState().staticMenuDesktopInactive &&
      this.layoutService.layoutConfig().menuMode === 'static'
    );
  });
  sidebarLogo = signal(
    this.appName === 'coassess'
      ? 'assets/coassess-logo-light.png'
      : 'assets/coreact-logo-light.png'
  );

  v = effect(() => console.log("sidebar menu items", this.layoutService.sidebarItems()))

  ngOnInit() {
  }
}
